import { graphql } from "gatsby"
import React from "react"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import ChangeHeaderInView from "../components/changeHeaderinView"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { COLOR_STATES } from "../context/menuContext"
import { useLanguage } from "../hooks/useLanguage"

export default function PrivacyPolicy({ data }) {
    const { switchLanguage } = useLanguage()
    const content = switchLanguage(data.privacyPolicy.contentJp, data.privacyPolicy.content)

    return (
        <Layout footer={false} hideCarousel>
            <Seo title='Privacy Policy' />
            <ChangeHeaderInView threshold={0.1} color={COLOR_STATES.DARK_WHITE_BG}>
                <div className='bg-white pt200 pb200 m-pt120px m-pb100'>
                    <div className='p60 m-p20 max-800 ma'>
                        <ReactMarkdown remarkPlugins={[remarkGfm]} className='legal-content post--content text-grey'>
                            {content}
                        </ReactMarkdown>
                    </div>
                </div>
            </ChangeHeaderInView>
        </Layout>
    )
}

export const query = graphql`
    query PrivacyPolicyPage {
        pageData: datoCmsPrivacyPolicy {
            content
        }
        privacyPolicy: datoCmsPrivacyPolicy {
            content
            contentJp
        }
    }
`
